import React, { useState } from 'react';
import { Button, Col, Form, message, Modal } from 'antd';
import { BookyInput, InputType } from '../Forms/BookyInput';
import { TextService } from '../../Services/TextService';
import { WebApiModelsExternalPayment, WebApiModelsPayment } from '../../Repository/eventbookyapi';
import { MemberService } from '../../Services/MemberService';
import { BookyButton } from '../Buttons/BookyButton';
import { BookySelectDropDown } from '../Forms/BookySelectDropDown';
import { getCurrentYearAsOption, getLastThreeYearAsOptions } from '../../Helpers/PaymentYearOptions';
import { getCurrentYearAsString, getPreviousYear } from '../../Helpers/DateHelpers';
import { OneFrontDatePicker } from '../Forms/BookyDatePicker';
import moment from 'moment';
import { IntegrationService } from '../../Services/IntegrationService';
import { LinkOutlined } from '@ant-design/icons';

export const AddPaymentLink = (props: any) => {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const GetText = TextService.GetText;
    const [payments, setPayments] = useState([] as WebApiModelsPayment[]);
    const [externalPayments, setExternalPayments] = useState([] as WebApiModelsExternalPayment[]);
    const [newlyCreatedUri, setnNewlyCreatedUri] = useState(null as string | null);

    const onCancel = () => {
        setnNewlyCreatedUri(null);
        form.setFieldValue("groupName", "");
        setOpen(false);
        props.loadMembers(false);
    };

    const onCreate = async () => {
        try {
            var response = await IntegrationService.CreatePaymentLink({
                memberId: Number(props.member.memberId),
                description: form.getFieldValue("description").toString(),
                amount: form.getFieldValue("amount"),
                paymentType: 1,
                paymentTypeEntity: form.getFieldValue("year").toString(),
            });

            setnNewlyCreatedUri(response.checkoutUrl!);
            form.setFieldValue("text", "");
        } catch (error) {
            message.warning(GetText("EditMember_ErrorSaving"));
            return;
        }
    }

    const deletePaymentLink = async () => {
        await IntegrationService.CancelPaymentLink(props.member.paymentLink);
        setOpen(false);
        loadPayments(false);
        props.loadMembers(false);
        message.success("Betallänken är borttagen och gäller inte längre.")
    }

    const onYearChanged = (selectedYear: string) => {
        var yearFound = false;
        payments.forEach((element: WebApiModelsPayment) => {
            if (element.year == selectedYear) {
                yearFound = true;
                form.setFieldValue("amount", element.amount);
                form.setFieldValue("paymentDate", moment(element.paymentDate));
            }
        });

        if (!yearFound) {
            form.setFieldValue("amount", "");
            form.setFieldValue("paymentDate", null);
        }
    }

    const loadPayments = (isFirstLoading: boolean) => {

        if (isFirstLoading) {
            form.setFieldValue("year", getPreviousYear(0));
        }

        MemberService.GetPayments(props.member.memberId).then(result => {
            setPayments(result.manualPayments!);
            setExternalPayments(result.externalPayments!);

            result.manualPayments!.forEach((element: WebApiModelsPayment) => {
                if (element.year == form.getFieldValue("year")) {
                    form.setFieldValue("amount", element.amount);
                    form.setFieldValue("paymentDate", moment(element.paymentDate));
                }
            });
        });
    }


    return (
        <>
            <Modal
                open={open}
                title={GetText("AddPaymentLink_ModalTitle") + " - (" + props.member.uniqueId + ") " + props.member.firstName + " " + props.member.lastName}
                width={700}
                okText={GetText("EditMember_ModalClose")}
                onOk={onCancel}
                onCancel={onCancel}
                cancelButtonProps={{ style: { display: 'none' } }}
            >
                {props.member.isPaidCurrentYear ? <p>Medlemmen har redan betalat för {getCurrentYearAsString()}</p> : ""}

                {props.member.paymentLink != null && props.member.isPaidCurrentYear == false ?
                    <>
                        Medlemmen kan använda följande länk för att betala medlemsavgiften för {getCurrentYearAsString()}:<br /> <a href={props.member.paymentLink} target="_blank">{props.member.paymentLink}</a><br /><br />
                        <BookyButton
                            danger
                            fullWidth={false}
                            text={"Radera betallänk"}
                            onClick={deletePaymentLink} /><br /><br />
                        <i>Du kan ta bort betalningen sålänge den inte är inbetald. Är länken redan utskickad till medlem kommer den inte längre fungera.</i>
                    </> : ""}<br />

                {newlyCreatedUri && props.member.isPaidCurrentYear == false ?
                    <>
                        Medlemmen kan använda följande länk för att betala medlemsavgiften för {getCurrentYearAsString()}:<br /> <a href={newlyCreatedUri} target="_blank">{newlyCreatedUri}</a><br /><br />
                        <BookyButton
                            danger
                            fullWidth={false}
                            text={"Radera betallänk"}
                            onClick={deletePaymentLink} />
                        <br /><br />
                        <i>Du kan ta bort betalningen sålänge den inte är inbetald. Är länken redan utskickad till medlem kommer den inte längre fungera.</i>

                    </> : ""}

                {newlyCreatedUri == null && props.member.paymentLink == null && props.member.isPaidCurrentYear == false ?
                    <Form form={form} colon={false} labelAlign={"left"} labelCol={{ span: 8, offset: 0 }} wrapperCol={{ span: 16 }} >
                        <Col span={17}>
                            <BookyInput label={GetText("AddPayment_Description")} onClick={onCreate} name="description" requiredMessage={"Du måste fylla i en beskrivning för betalningen."} placeholder={"T.ex. 'Medlemsavgift 2025'"} />

                            <BookyInput type={InputType.number} label={GetText("AddPayment_NoteColumnPlaceHolder")} requiredMessage={"Du måste fylla i ett belopp."} onClick={onCreate} name="amount" req placeholder={GetText("AddPayment_NoteColumnPlaceHolder")} />
                            <BookySelectDropDown label={GetText("AddPayment_YearColumn")} name="year" handleChange={onYearChanged} options={getCurrentYearAsOption()} />
                            <Form.Item label={" "}>
                                <BookyButton
                                    type="primary"
                                    fullWidth={false}
                                    text={"Skapa betallänk"}
                                    onClick={onCreate}
                                >
                                </BookyButton>
                            </Form.Item>
                        </Col>
                    </Form> : ""}
            </Modal>
            <LinkOutlined className={props.member.paymentLink != null ? "" : "not-payed"}
                style={{ fontSize: "20px" }}
                type="primary"
                onClick={() => {
                    setOpen(true);
                    loadPayments(true);
                }}
            >
            </LinkOutlined>
        </>
    );
};

export default AddPaymentLink;